export const updateHotelSystemsDigitalCheckinConfig = `
  mutation MyMutation(
    $hotelId: String!,
    $personalisation: Boolean,
    $checkInAvailability: String,
    $accompanyingGuestDetails: ConfigurationInput,
    $covid19Documents: ConfigurationInput,
    $eRegistrationDestination: ERegistrationDestinationInput,
    $eRegistrationForm: ERegistrationFormInput,
    $guestDocumentTypes: [DocumentTypeInput],
    $holdAmountConfig: HoldAmountConfigInput,
    $integrationSource: DigitalCheckinIntegrationSourceInput,
    $apiIntegration: DigitalCheckinAPIIntegrationInput
  ) {
    updateHotelSystemsDigitalCheckinConfig(
      input: {
        hotelId: $hotelId,
        personalisation: $personalisation,
        checkInAvailability: $checkInAvailability,
        accompanyingGuestDetails: $accompanyingGuestDetails,
        covid19Documents: $covid19Documents,
        eRegistrationDestination: $eRegistrationDestination,
        eRegistrationForm: $eRegistrationForm,
        guestDocumentTypes: $guestDocumentTypes,
        holdAmountConfig: $holdAmountConfig,
        apiIntegration: $apiIntegration,
        integrationSource: $integrationSource
    }) {
      message
      status
    }
  }
  `;

export const updateRoomReservationConfigs = `
  mutation MyMutation(
    $hotelId: String!,
    $payAtProperty: Boolean!,
    $payNow: Boolean!,
    $payment: Boolean!,
    $promoCode: Boolean!,
    $roomUpgrades: Boolean!,
    $modifyBooking: BookingInput!,
    $cancelBooking: BookingInput!,
    $apiIntegrationHotelId: String!,
    $apiIntegrationURL: String!,
    $integrationSource: String!,
    $integrationSourceType: String!,
  ) {
    updateRoomReservations(
      input: {
        hotelId: $hotelId, 
        payAtProperty: $payAtProperty, 
        payNow: $payNow, 
        payment: $payment, 
        promoCode: $promoCode, 
        roomUpgrades: $roomUpgrades, 
        modifyBooking: $modifyBooking, 
        cancelBooking: $cancelBooking,
        apiIntegrationHotelId: $apiIntegrationHotelId,
        apiIntegrationURL: $apiIntegrationURL,
        integrationSource: $integrationSource,
        integrationSourceType: $integrationSourceType
      }) {
      message
      status
    }
  } 
  `;

export const updateHotelSystemSettings = `
  mutation MyMutation(
    $hotelId: String!, 
    $digitalCheckIn: Boolean!, 
    $digitalCheckOut: Boolean!, 
    $housekeeping: Boolean!, 
    $inRoomDinning: Boolean!, 
    $roomReservations: Boolean!, 
    $spaReservation: Boolean!, 
    $tableReservation: Boolean!, 
    $telephony: Boolean!
    $loyalty: Boolean
    $payment: Boolean
    $weather: Boolean
    $documentScan: Boolean
    $travelService: Boolean
    $chat: Boolean
    $eventHub: Boolean
    $analytics: Boolean
    $thirdPartyNotificationService: Boolean
    $centralReservationSystem: Boolean
  ) {
    updateHotelSystemsSetting(
      input: {
        hotelId: $hotelId, 
        digitalCheckIn: $digitalCheckIn, 
        digitalCheckOut: $digitalCheckOut, 
        housekeeping: $housekeeping, 
        inRoomDinning: $inRoomDinning, 
        roomReservations: $roomReservations, 
        spaReservation: $spaReservation, 
        tableReservation: $tableReservation, 
        telephony: $telephony
        loyalty: $loyalty
        payment: $payment
        weather: $weather
        documentScan: $documentScan
        travelService: $travelService
        chat: $chat
        eventHub: $eventHub
        analytics: $analytics
        thirdPartyNotificationService: $thirdPartyNotificationService
        centralReservationSystem: $centralReservationSystem
      }) {
      message
      status
     }
    }
  `;

export const createTemplate = `
  mutation MyMutation(
    $hotelId: String!
    $name: String!
    $thermostatVendor: VendorInput!
    $curtainVendor: VendorInput!
    $lightVendor: VendorInput!
    $sceneVendor: VendorInput!
    $doorLockVendor: VendorInput!
    $doorLock: GenericPropertyInput
    $areas: [TemplateRoomAreaInput]
    $doorCameraEnabled: Boolean
  ) {
    createTemplate(
      input: {
        name: $name
        hotelId: $hotelId
        thermostatVendor: $thermostatVendor
        scenesVendor: $sceneVendor
        lightsVendor: $lightVendor
        curtainsVendor: $curtainVendor
        doorLockVendor: $doorLockVendor
        doorLock: $doorLock
        areas: $areas
        doorCameraEnabled: $doorCameraEnabled
      }
    ) {
      status
      message
    }
  }
  `;

export const UpdateRoomConfigurations = `
    mutation MyMutation(
      $hotelId: String!
      $area: RoomAreaUpdateInput
      $dnd: CustomConfigInput
      $ddk: CustomConfigInput
      $mmr: CustomConfigInput
      $dc: DoorCameraConfigInput
      $doorLock: PropertyInput
      $roomId: Int!
    ) {
      UpdateRoomConfigurations(
        input: {
          area: $area
          ddk: $ddk
          dnd: $dnd
          mmr: $mmr
          dc: $dc
          doorLock: $doorLock
          hotelId: $hotelId
          roomId: $roomId
        }
      ) {
        message
        status
      }
    }
  `;

export const updateTemplate = `
  mutation MyMutation(
    $hotelId: String!,
    $id: String!,
    $name : String!, 
    $thermostatVendor: VendorInput!, 
    $curtainVendor: VendorInput!, 
    $lightVendor: VendorInput!,
    $sceneVendor: VendorInput!,
    $doorLockVendor: VendorInput!
    $doorLock: GenericPropertyInput
    $areas: [TemplateRoomAreaInput]
    $doorCameraEnabled: Boolean
  ) {
    updateTemplate(
      input: {
        hotelId: $hotelId, 
        id: $id, 
        name: $name, 
        thermostatVendor: $thermostatVendor, 
        scenesVendor: $sceneVendor, 
        lightsVendor: $lightVendor, 
        curtainsVendor: $curtainVendor, 
        doorLockVendor: $doorLockVendor
        doorLock: $doorLock
        areas: $areas
        doorCameraEnabled: $doorCameraEnabled
      }) {
      message
      status
    }
  }  
  `;

export const duplicateTemplate =
  /* Graphql */
  `
  mutation MyMutation($hotelId: String!, $id: String!) {
    duplicateTemplate(input: {hotelId: $hotelId, id: $id}) {
      message
      status
    }
  }
  `;

export const deleteTemplate =
  /* Graphql */
  `
  mutation MyMutation($hotelId: String!, $id: String!) {
    deleteTemplate(input: {hotelId: $hotelId, id: $id}) {
      message
      status
    }
  }
  `;

export const createRoomConfigurations =
  /* Graphql */
  `
  mutation MyMutation($hotelId: String!, $templateId: String!, $rangeList: [RangeInput!]) {
    CreateRoomConfigurations(input: {rangeList: $rangeList, hotelId: $hotelId, templateId: $templateId}) {
      message
      status
    }
  }
  `;

export const DeleteRoomConfigurations =
  /* Graphql */
  `
  mutation MyMutation($hotelId: String!, $roomId: Int!) {
    DeleteRoomConfigurations(input: {hotelId: $hotelId, roomId: $roomId}) {
      message
      status
    }
  }
  
  `;

export const createOrUpdateSpaReservationConfig = `
  mutation MyMutation(
    $hotelId: String!
    $spaId: String!
    $pos: POSInput!
    $treatmentList: Boolean!
    $multipleHours: Boolean!
    $booking: BookingConfigInput!
  ) {
    createOrUpdateSpaReservationConfig(input: {
        hotelId: $hotelId,
        multipleHours: $multipleHours,
        pos: $pos
        spaId: $spaId, 
        treatmentList: $treatmentList, 
        booking: $booking
      }) {
      message
      status
    }
  }`;

export const createOrUpdateRestaurantConfig = `
mutation MyMutation(
  $hotelId: String!
  $restaurantId: String!
) {
  createOrUpdateRestaurantConfig(input: {
    hotelId: $hotelId
    restaurantId: $restaurantId   
  }) {
    message
    status
  }
}`;

export const createOrUpdateTelephonyConfig = `
mutation MyMutation(
  $epbx: TelephonyDetailInput!
  $hotelId: String!
  $portTLS: Boolean!
  $portTLSSecondary: String!
  $sbcA1: TelephonyDetailInput!
  $sbcEmsServer: TelephonyDetailInput!
  $sbcEmsServerSecondary: TelephonyDetailInput!
  $securityModule: TelephonyDetailInput!
  $sessionManager: TelephonyDetailInput!
  $sessionManagerSecondary: TelephonyDetailInput!
  $sipDomain: String!
) {
  createOrUpdateTelephonyConfig(input: {
    epbx: $epbx
    hotelId: $hotelId
    portTLS: $portTLS
    portTLSSecondary: $portTLSSecondary
    sbcA1: $sbcA1
    sbcEmsServer: $sbcEmsServer
    sbcEmsServerSecondary: $sbcEmsServerSecondary
    securityModule: $securityModule
    sessionManager: $sessionManager
    sessionManagerSecondary: $sessionManagerSecondary
    sipDomain: $sipDomain
  }) {
    message
    status
  }
}`;

export const saveGlobalDoorCameraConfigs = `
mutation MyMutation(
  $hotelId:String!
  $ipAddress: String!
  $password: String!
  $port: String!
  $provider: String!
  $username: String!
) {
  saveGlobalDoorCameraConfigs(input: {
    hotelId: $hotelId
    ipAddress: $ipAddress
    password: $password
    port: $port
    provider: $provider
    username: $username}) {
    message
    status
  }
}`;

export const deleteConnectionConfig = `
mutation MyMutation(
  $hotelId:String!
  $integrationType: String!
) {
  deleteConnectionConfig(input: {
    hotelId: $hotelId
    integrationType: $integrationType
   }) {
    message
    status
  }
}`;

export const createAppConfigurationMutation = `
  mutation MyMutation(
    $configuration: String!
    $description: String!
    $hotelId: String!
    $name: String!
    $userName: String!
    $type: String!
    $channelType: String
    $pwaURLCode: String
    $productURLCode: String
  ) {
    createAppConfiguration(input: {
      configuration: $configuration
      description: $description
      hotelId: $hotelId
      name: $name
      userName: $userName
      type: $type
      channelType: $channelType
      pwaURLCode: $pwaURLCode
      productURLCode: $productURLCode
    }) {
    id
  }
}`;

export const updateAppConfigurationMutation = `
  mutation MyMutation(
    $id: String!
    $configuration: String!
    $description: String!
    $hotelId: String!
    $name: String!
    $userName: String!
    $type: String!
    $channelType: String
    $pwaURLCode: String
    $productURLCode: String
  ) {
    updateAppConfiguration(input: {
      id: $id
      configuration: $configuration
      description: $description
      hotelId: $hotelId
      name: $name
      userName: $userName
      type: $type
      channelType: $channelType
      pwaURLCode: $pwaURLCode
      productURLCode: $productURLCode
    }) {
    id
  }
}`;
